export default "__VITE_ASSET__ce0b1d65__"